<template>
  <div>
    <div class="filter-row" style="">
      <div style="float:right">
        <Button type="info" @click="uploadModal=true" icon="md-cloud-upload">上传数据</Button>
        <!-- <Divider type="vertical" /> -->
        <!-- <Button @click="relation('all')" icon="md-link">关联公式</Button> -->
      </div>
      筛选：
      <Input v-model="params.username" placeholder="姓名" clearable style="width:120px" @on-enter="getAttendBase"></Input>
      <!-- <Cascader v-model="params.department_id" placeholder="选择项目组" @on-change="getAttendBase" style="width:140px;display:inline-block" :data=""></Cascader> -->
      <Select @on-change="getAttendBase" v-model="params.department_id" placeholder="选择项目" style="width: 120px">
        <Option v-for="(item, ind) in $store.state.department" :value="item.value" :key="ind">{{item.label}}</Option>
      </Select>
      <Button icon="md-search" @click="getAttendBase"/>
      <!-- <Divider type="vertical" /> -->
    </div>
    <div class="ivu-table-wrapper">
      <div class="ivu-table ivu-table-default ivu-table-border">
       <div class="ivu-table-body ivu-table-overflowX">
         <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
          <colgroup>
            <col width="70">
            <col width="80">
            <template v-for="field in fields">
              <template v-for="(item,ind) in field.children">
                <col width="130" :key="ind">
              </template>
            </template>
            <col width="100">
            <col width="100">
          </colgroup>
            <thead>
              <tr>
                <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">#</span></div></th>
                <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">姓名</span></div></th>
                <template v-for="(field,ind) in fields">
                  <th class="ivu-table-column-center" :key="ind" :colspan="field.children.length"><div class="ivu-table-cell"><span class="">{{field.name}}</span></div></th>
                </template>
                <th class="ivu-table-column-center" rowspan="2">
                  <div class="ivu-table-cell">
                    <span>公式</span>
                  </div>
                </th>
                <th class="ivu-table-column-center" rowspan="2">
                  <div class="ivu-table-cell">
                    <span>操作</span>
                  </div>
                </th>
              </tr>
              <tr>
                <template v-for="field in fields">
                  <template v-for="(item,ind) in field.children">
                    <th class="ivu-table-column-center" :key="ind"><div class="ivu-table-cell"><span class="">{{item.name}}</span></div></th>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody class="ivu-table-body ivu-table-overflowX">
              <template v-for="(item, index) in users.data">
                <tr class="ivu-table-row" :key="index">
                  <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.id}}</span></div></td>
                  <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.username}}</span></div></td>
                  <template v-for="row in item.salary_base">
                  <td class="ivu-table-column-center" v-if="item.salary_base.length>0" :key="row.id">
                    <div class="ivu-table-cell">
                      <span>{{row.value}}</span>
                    </div>
                  </td>
                  </template>

                  <td class="ivu-table-column-center" :colspan="fields.length" v-if="item.salary_base.length==0"><div class="ivu-table-cell"><span>--</span></div></td>

                  <td class="ivu-table-column-center">
                    <div class="ivu-table-cell">
                      <!-- <Button @click="addData(item.id)">添加</Button> -->
                    </div>
                  </td>
                 </tr>
               </template>
           </tbody>
         </table>
       </div>
       <div class="ivu-table-fixed" style="width: 150px;">
         <div class="ivu-table-fixed-header">
           <table cellspacing="0" cellpadding="0" border="0" style="width: 150px;">
             <colgroup>
               <col width="70">
               <col width="80">
               <template v-for="field in fields">
                 <template v-for="(item, ind) in field.children">
                   <col width="130" :key="ind">
                 </template>
               </template>
               <col width="100">
               <col width="100">
             </colgroup>
             <thead>
               <tr>
                 <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">#</span></div></th>
                 <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">姓名</span></div></th>
                 <th class="ivu-table-hidden" :colspan="fields.length"><div class="ivu-table-cell"><span class="">基础数据</span></div></th>
                 <th class="ivu-table-column-center" rowspan="2">
                   <div class="ivu-table-cell">
                     <span>公式</span>
                   </div>
                 </th>
                 <th class="ivu-table-column-center" rowspan="2">
                   <div class="ivu-table-cell">
                     <span>操作</span>
                   </div>
                 </th>
               </tr>
               <tr>
              <th class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">&nbsp;</span></div></th>
               </tr>
             </thead>
             <tbody class="ivu-table-body ivu-table-overflowX">
               <template v-for="(item, index) in users.data">
                 <tr class="ivu-table-row" :key="index">
                   <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.id}}</span></div></td>
                   <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.username}}</span></div></td>
                  <template  v-for="row in item.salary_base">
                   <td class="ivu-table-hidden" v-if="item.salary_base.length>0" :key="row.id"><div class="ivu-table-cell"><span>{{row.value}}</span></div></td>
                  </template>
                   <td class="ivu-table-hidden" :colspan="fields.length" v-if="item.salary_base.length==0"><div class="ivu-table-cell"><span>--</span></div></td>

                   <td class="ivu-table-column-center">
                     <!-- <div class="ivu-table-cell">
                       <Button @click="addData(item.id)">{{item.salary_base.length==0?'添加':'修改'}}</Button>
                     </div> -->
                   </td>
                 </tr>
               </template>
             </tbody>
           </table>
         </div>
       </div>
       <div class="ivu-table-fixed-right" style="width: 200px;">
         <div class="ivu-table-fixed-header">
           <table cellspacing="0" cellpadding="0" border="0" style="width: 200px;">
             <colgroup>
               <col width="100">
               <col width="100">
               <col width="80">
               <col width="100">
               <template v-for="field in fields">
                 <template v-for="(item,index) in field.children">
                   <col width="130" :key="index"></col>
                 </template>
               </template>
             </colgroup>
             <thead>
               <tr>
                 <th class="ivu-table-column-center" rowspan="2">
                   <div class="ivu-table-cell">
                     <span>公式</span>
                   </div>
                 </th>
                 <th class="ivu-table-column-center" rowspan="2">
                   <div class="ivu-table-cell">
                     <span>操作</span>
                   </div>
                 </th>
                 <th class="ivu-table-hidden" rowspan="2"><div class="ivu-table-cell"><span class="">#</span></div></th>
                 <th class="ivu-table-hidden" rowspan="2"><div class="ivu-table-cell"><span class="">姓名</span></div></th>
                 <th class="ivu-table-hidden" :colspan="fields.length"><div class="ivu-table-cell"><span class="">基础数据</span></div></th>
               </tr>
               <tr>
                   <th class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">&nbsp;</span></div></th>
               </tr>
             </thead>
             <tbody class="ivu-table-body ivu-table-overflowX">
               <template v-for="(item, index) in users.data">
                 <tr class="ivu-table-row" :key="index">
                   <td class="ivu-table-column-center">
                     <div class="ivu-table-cell" v-if="item.salary_formula">
                       <div style="color:#999">已关联</div>
                       <Tooltip content="编辑">
                         <Button style="padding:0 4px;" size="small" @click="formulaId=item.formula_id;relation(item.id)" icon="md-create"></Button>
                       </Tooltip>
                       <Tooltip content="测试">
                         <Button style="padding:0 4px;" size="small" icon="md-build" @click="formulaTest(item.id)"></Button>
                       </Tooltip>
                     </div>
                     <div class="ivu-table-cell" v-else>
                       <span style="color:#999">未关联</span>
                       <Button size="small" @click="relation(item.id)">关联</Button>
                     </div>
                   </td>
                   <td class="ivu-table-column-center">
                     <div class="ivu-table-cell">
                       <Button @click="addData(item)" :type="item.salary_base.length==0?'info':'success'" size="small" icon="md-create">{{item.salary_base.length==0?'添加':'修改'}}</Button>
                     </div>
                   </td>
                   <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.id}}</span></div></td>
                   <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.username}}</span></div></td>
                   <template v-for="row in item.salary_base">
                   <td class="ivu-table-hidden" v-if="item.salary_base.length>0" :key="row.id"><div class="ivu-table-cell"><span>{{row.value}}</span></div></td>
                   </template>
                   <td class="ivu-table-hidden" :colspan="fields.length" v-if="item.salary_base.length==0"><div class="ivu-table-cell"><span>--</span></div></td>
                 </tr>
               </template>
             </tbody>
           </table>
         </div>
       </div>
     </div>
   </div>
   <div class="pager" v-if="users && users.data.length>0"><Page :current="users.page" :page-size="users.per_page" :total="users.total" @on-change="pagerChange"></Page></div>
   <div class="center" style="padding:40px;color:#999" v-else>-- 暂无数据 --</div>
    <Modal
      v-model="fieldsModal"
      width="600px"
      @on-ok="submit"
      title="薪资基础数据">
      <Form :model="formItem">
        <Tabs type="card">
          <TabPane :label="field.name" :name="''+field.id" v-for="field in fields" :key="field.id" style="margin-bottom:10px" size="small">
            <Row :gutter="10">
            <!-- <h5 style="clear:both;border-bottom:1px solid #eee;">{{field.name}}</h5> -->
            <Col :span="24" v-for="(item, index) in field.children" :key="index">
              <FormItem :label="item.name" v-if="item.type=='input'">
                  <Input v-model="formItem[item.label].value">
                    <span slot="append">{{item.unit}}</span>
                  </Input>
              </FormItem>
              <FormItem :label="item.name" v-else-if="item.type=='select'">
                  <Select v-model="formItem[item.label].value">
                    <Option v-for="(opt, ind) in formItem[item.label].default" :value="opt" :label="opt" :key="ind">{{opt}}</Option>
                  </Select>
                  <span style="position:absolute;top:0;right:10px;color:#999">单位：{{item.unit}}</span>
              </FormItem>
              <FormItem :label="item.name" v-else-if="item.type=='textarea'">
                  <Input type="textarea" v-model="formItem[item.label].value"></Input>
              </FormItem>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
      </Form>
    </Modal>
    <Modal
        v-model="uploadModal"
        title="导入基础数据"
        width="340"
        :mask-closable="false">
        <div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :on-success="handleSalarySuccess"
            :format="['xls','xlsx']"
            :max-size="10048"
            :data="{file_type:'salary_table'}"
            :headers="uploadHeaders"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            v-show="uploadState==0"
            :action="uploadApiPath"
             class="upload-item" style="margin:0">
              <div style="width:100%;padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>选择文件</p>
              </div>
          </Upload>
          <div v-show="uploadState==1" style="text-align:center">正在努力更新，请稍等</div>
        </div>
        <div slot="footer">
      </div>
    </Modal>
    <Modal v-model="formulaModal" @on-cancel="formulaId = ''" title="关联公式" width="800">
      <RadioGroup v-model="formulaId" class="formula-group">
        <ul class="">
            <li  v-if="formulas.data.length==0">暂无数据</li>
            <li v-for="(item, ind) in formulas.data" :key="ind">
              <div style="float:right">
                <Button type="text" size="small" @click="editFormula(item)">编辑</Button>
              </div>
              <Radio :label="item.id">{{item.name}}</Radio>
            </li>
        </ul>
      </RadioGroup>
      <footer slot="footer">
        <Button type="text" @click="startFormula">+ 创建公式</Button>
        <Button type="primary" @click="bindingFormula">绑定</Button>
      </footer>
    </Modal>
    <Modal v-model="createFormulaModal" title="创建公式" width="900" @on-cancel="getFormulas">
      <Row :gutter="16">
        <Col span="24">
          <div>名称:</div>
          <Input v-model="formulaForm.name" placeholder="名称"></Input>
        </Col>
      </Row>
      <br/>
      <Row :gutter="16">
        <Col span="8">应发公式：(拖动到框里生成公式)</Col>
        <Col span="8">应扣公式：(拖动到框里生成公式)</Col>
        <Col span="8">可报销公式：(拖动到框里生成公式)</Col>
      </Row>
      <Row :gutter="16">
        <Col span="8">
          <draggable
            class="dragArea formula-box"
            :list="pay_formula"
            group="formula"
            style="border:1px dotted #fc0;padding:20px;box-shadow: 0 0 10px #ddd"
            @change="formulaChange('pay')"
            >
            <Tag :key="ind" class="item" v-for="(item, ind) in pay_formula" type="border" style="border:none !important;overflow:visible" :color="item.color">
              <InputNumber v-model="item.value" @on-change="formulaChange('pay')" size="small" style="width:80px;" v-if="item.type=='inp'"/>
              <span style="font-size:13px;" v-else>{{item.name}}</span>
              <span class="item-close" @click="removeFormulaItem(ind, 'pay_formula')"><Icon type="md-close"></Icon></span>
            </Tag>
        </draggable>
      </Col>
      <Col span="8">
        <draggable
          class="dragArea formula-box"
          :list="deduct_formula"
          group="formula"
          style="border:1px dotted #fc0;padding:20px;box-shadow: 0 0 10px #ddd"
          @change="formulaChange('deduct')"
          >
          <Tag :key="ind" class="item" v-for="(item, ind) in deduct_formula" type="border" style="border:none !important;overflow:visible" :color="item.color">
            <InputNumber v-model="item.value" @on-change="formulaChange('deduct')" size="small" style="width:80px;" v-if="item.type=='inp'"/>
            <span style="font-size:13px;" v-else>{{item.name}}</span>
            <span class="item-close" @click="removeFormulaItem(ind, 'deduct_formula')"><Icon type="md-close"></Icon></span>
          </Tag>
        </draggable>
      </Col>
      <Col span="8">
        <draggable
          class="dragArea formula-box"
          :list="expense_formula"
          group="formula"
          style="border:1px dotted #fc0;padding:20px;box-shadow: 0 0 10px #ddd"
          @change="formulaChange('expense')"
          >
          <Tag :key="ind" class="item" v-for="(item, ind) in expense_formula" type="border" style="border:none !important;overflow:visible" :color="item.color">
            <InputNumber v-model="item.value" @on-change="formulaChange('expense')" size="small" style="width:80px;" v-if="item.type=='inp'"/>
            <span style="font-size:13px;" v-else>{{item.name}}</span>
            <span class="item-close" @click="removeFormulaItem(ind, 'expense_formula')"><Icon type="md-close"></Icon></span>
          </Tag>
        </draggable>
      </Col>
      </Row>
      <br/>
      <Row :gutter="16">
        <Col span="8">
          <div style="padding: 10px 0 0">薪资组成：</div>
          <draggable :list="fieldsChildren" v-if="fieldsChildren.length>0" draggable=".item" :group="{ name: 'formula', pull: 'clone'}" style="border:1px solid #eee;padding:20px">
              <Tag :key="ind" class="item" :color="child.color" v-for="(child, ind) in fieldsChildren"><span style="font-size:13px;">{{child.name}}</span></Tag>
          </draggable>
        </Col>
        <Col span="8">
          <div style="padding: 10px 0 0">考勤字段：</div>
          <draggable :list="days" v-if="days.length>0" draggable=".item" :group="{ name: 'formula', pull: 'clone', put: false }" style="border:1px solid #eee;padding:20px">
            <Tag :key="ind" class="item" :color="item.color" v-for="(item, ind) in days"><span style="font-size:13px;">{{item.name}}</span></Tag>
          </draggable>
        </Col>
        <Col span="8">
          <div style="padding: 10px 0 0">操作符：</div>
          <draggable :list="operators" draggable=".item" v-if="operators.length>0" :group="{ name: 'formula', pull: 'clone', put: false }" style="border:1px solid #eee;padding:20px">
            <Tag :key="ind" class="item" :color="item.color" v-for="(item, ind) in operators"><span style="font-size:13px;">{{item.name}}</span></Tag>
          </draggable>
        </Col>
      </Row>
      <footer slot="footer">
        <Button type="primary" @click="createFormula">确定</Button>
      </footer>
    </Modal>
    <Modal v-model="testFormulaModal" title="测试公式" width="400">
      <div style="text-align:center;margin-bottom:10px">
        选择考勤数据
        <DatePicker type="month" format="yyyy-M" @on-change="dateChange" @on-clear="testYearMonth=''" placeholder="年/月" style="width: 100px"></DatePicker>
        <Button icon="md-build" @click="startTestFormula">测试</Button>
      </div>
          <Card :bordered="false" :dis-hover="true" title="应发合计：" style="margin-bottom:10px;">
            <template v-if="testData.pay_total!==''">
              {{testData.pay_detail}} =
              {{testData.pay_total}}
            </template>
          </Card>
          <Card :bordered="false" :dis-hover="true" title="应扣合计：" style="margin-bottom:10px;">
            <template v-if="testData.pay_total!==''">
              {{testData.deduct_detail}} =
              {{testData.deduct_total}}
            </template>
          </Card>
          <Alert type="warning">本月实发薪资：{{testData.pay_total?(testData.pay_total - testData.deduct_total):'--'}}</Alert>
          <Card :bordered="false" :dis-hover="true" title="报销合计：">
            <template v-if="testData.pay_total!==''">
              {{testData.expense_detail}} =
              {{testData.expense_total}}
            </template>
          </Card>
          <Alert type="warning">本月工资总额：{{testData.pay_total?(testData.pay_total - testData.deduct_total + testData.expense_total):'--'}}</Alert>
      <footer slot="footer">
        <Button @click="saveSalaryData">保存数据</Button>
      </footer>
    </Modal>
   </div>
</template>

<script>
import {post, fetch} from '../fetch/api'
import draggable from 'vuedraggable'
const formulaBase = {
  id: 0,
  name: '',
  pay_formula: '',
  deduct_formula: '',
  expense_formula: '',
  pay_detail: '',
  deduct_detail: '',
  expense_detail: ''
}
export default {
  name: 'AnalysisForm',
  props: {
  },
  data () {
    let token = localStorage.getItem('token')

    return {
      users: {
        data: []
      },
      fields: [],
      fieldsChildren: [],
      uploadModal: false,
      uploadList: [],
      uploadState: 0,
      uploadApiPath: '/api/users/upload/salary/base',
      uploadHeaders: {
        'Authorization': `Bearer ${token}`
      },
      userId: 0,
      fieldsModal: false,
      formItem: {},
      params: {
        page: 1,
        username: '',
        department_id: 0
      },
      formulaId: '',
      formulas: {
        data: []
      },
      formulasParams: {
        page: 1
      },
      formulaModal: false,
      createFormulaModal: false,
      testFormulaModal: false,
      testYearMonth: '',
      testData: {
        pay_detail: '',
        pay_total: '',
        deduct_detail: '',
        deduct_total: '',
        expense_detail: '',
        expense_total: ''
      },
      formulaForm: JSON.parse(JSON.stringify(formulaBase)),
      pay_formula: [],
      deduct_formula: [],
      expense_formula: [],
      days: [
        {name: '出勤天数', label: '$cqday'},
        {name: '出差天数', label: '$ccday'}, // 出差
        {name: '加班天数', label: '$jbday'},
        {name: '实习天数', label: '$sxday'},
        {name: '培训天数', label: '$pxday'},
        {name: '假期天数', label: '$jqday'},
        {name: '年休天数', label: '$nxday'},
        {name: '婚产天数', label: '$hcjday'},
        {name: '病假天数', label: '$bjday'},
        {name: '丧假天数', label: '$sjday'},
        {name: '事假天数', label: '$shijday'},
        {name: '旷工天数', label: '$kgday'},
        {name: '离职天数', label: '$lzday'},
        {name: '招聘天数', label: '$zpday'}
      ],
      operators: [
        {name: '+', label: '+', color: 'orange'},
        {name: '-', label: '-', color: 'orange'},
        {name: 'X', label: '*', color: 'orange'},
        {name: '/', label: '/', color: 'orange'},
        {name: '(', label: '(', color: 'orange'},
        {name: ')', label: ')', color: 'orange'},
        {name: '输入框', label: '1', color: 'green', type: 'inp'}
      ]
    }
  },
  watch: {
  },
  components: {
    draggable
  },
  filters: {
  },
  mounted () {
    this.getAttendBase()
    this.getSalaryFields()
  },
  methods: {
    getSalaryFields () {
      fetch('/users/salary/fields').then(res => {
        var data = res
        var childData = []
        for (var k in data) {
          if (data.hasOwnProperty(k)) {
            for (var i in data[k].children) {
              if (data.hasOwnProperty(k)) {
                var def = data[k].children[i].default
                var value = data[k].children[i].default
                if (data[k].children[i].type === 'select') {
                  def = data[k].children[i].default.split(',')
                  value = def[0]
                }
                let obj = {value: String(value), name: String(data[k].children[i].name), label: data[k].children[i].label, default: def, type: data[k].children[i].type}
                childData.push(obj)
                this.formItem[data[k].children[i].label] = obj
              }
            }
          }
        }
        this.fieldsChildren = childData
        this.fields = res
      })
    },
    pagerChange (page) {
      this.params.page = page
      this.getAttendBase()
    },
    getAttendBase () {
      fetch('/users/salary/base', {params: this.params}).then(res => {
        this.users = res
      })
    },
    addData (row) {
      this.userId = row.id
      this.fieldsModal = true
      if (row.salary_base.length > 0) {
        for (let k in row.salary_base) {
          if (row.salary_base.hasOwnProperty(k)) {
            this.formItem[row.salary_base[k].label].value = row.salary_base[k].value
          }
        }
      } else {
        var data = this.fields
        for (let k in data) {
          if (data.hasOwnProperty(k)) {
            this.formItem[data[k].label].value = this.formItem[data[k].label].default
          }
        }
      }
    },
    submit () {
      post(`/users/salary/base/${this.userId}`, {data: this.formItem}).then(res => {
        if (res.status === 'success') {
          this.$Message.success('操作成功')
          this.getAttendBase()
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    handleSalarySuccess (res) {
      if (res.status === 'ok') {
        this.uploadState = 0
      // this.attendSalaryMonth = res.time
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '上传错误',
        desc: '您上传的文件可能有误【' + file.name + '】, 请选择xls/xlsx文件.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: '文件太大',
        desc: '文件  ' + file.name + ' 太大了, 请不要超过 2M.'
      })
    },
    handleBeforeUpload () {
      const check = this.uploadList.length <= 1
      this.uploadState = 1
      if (!check) {
        this.uploadState = 0
        this.$Notice.warning({
          title: '一次只能选择一个文件！'
        })
      }
      return check
    },
    relation (uid) {
      this.userId = uid
      this.formulaModal = true
      this.getFormulas()
    },
    submitFormula () {
      post('/users/salary/formula', this.formulaForm).then(res => {
        if (res.status === 'success') {
          this.$Notice.success({title: res.msg})
          this.getFormulas()
        } else {
          this.$Notice.error({title: res.msg})
        }
      })
    },
    getFormulas () {
      fetch('/users/salary/formulas', {params: this.formulasParams}).then(res => {
        this.formulas = res
      })
    },
    formulaChange (name) {
      let str = ''
      let detail = []
      for (var k in this[name + '_formula']) {
        if (this[name + '_formula'].hasOwnProperty(k)) {
          str += this[name + '_formula'][k].label
          detail.push(this[name + '_formula'][k])
        }
      }
      this.formulaForm[name + '_formula'] = str
      this.formulaForm[name + '_detail'] = JSON.stringify(detail)
    },
    removeFormulaItem (ind, name) {
      this[name].splice(ind, 1)
      name = name.split('_')
      this.formulaChange(name[0])
    },
    startFormula () {
      this.formulaForm = JSON.parse(JSON.stringify(formulaBase))
      this.pay_formula = ''
      this.deduct_formula = ''
      this.expense_formula = ''
      this.createFormulaModal = true
    },
    editFormula (data) {
      this.formulaForm.id = data.id
      this.formulaForm.name = data.name
      this.pay_formula = JSON.parse(data.pay_detail)
      this.deduct_formula = JSON.parse(data.deduct_detail)
      this.expense_formula = JSON.parse(data.expense_detail)
      this.formulaForm.pay_formula = data.pay_formula
      this.formulaForm.deduct_formula = data.deduct_formula
      this.formulaForm.expense_formula = data.expense_formula
      this.createFormulaModal = true
    },
    createFormula () {
      if (!this.formulaForm.name) {
        this.$Message.error('请输入名称')
        return
      }
      console.log(this.formulaForm)
      post('/users/salary/formula', this.formulaForm).then(res => {
        if (res.status === 'success') {
          this.$Message.success(res.msg)
        } else {
          this.$Message.error(res.msg)
        }
        this.createFormulaModal = false
      })
    },
    bindingFormula () {
      if (this.formulaId === '') {
        this.$Message.error('请选择一个公式')
        return false
      }
      post(`/users/binding/formula/${this.userId}`, {formula_id: this.formulaId}).then(res => {
        if (res.status === 'success') {
          this.$Message.success(res.msg)
          this.getAttendBase()
          this.formulaModal = false
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    dateChange (date) {
      this.testYearMonth = date
    },
    formulaTest (id) {
      this.userId = id
      this.testData = {
        pay_detail: '',
        pay_total: '',
        deduct_detail: '',
        deduct_total: '',
        expense_detail: '',
        expense_total: ''
      }
      this.testFormulaModal = true
    },
    startTestFormula () {
      if (this.testYearMonth === '') {
        this.$Message.error('请选择日期')
        return false
      }
      let date = this.testYearMonth.split('-')
      post(`/users/formula/test/${this.userId}`, {year: date[0], month: date[1]}).then(res => {
        if (res.status === 'success') {
          this.testData = res.data
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    saveSalaryData () {
      if (this.testYearMonth === '') {
        this.$Message.error('请选择日期')
        return false
      }
      let date = this.testYearMonth.split('-')
      post(`/users/salary/save/${this.userId}`, {year: date[0], month: date[1]}).then(res => {
        if (res.status === 'success') {
          // this.testData = res.data
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formula-group{display: block}
.formula-group li{border-bottom:1px solid #eee;padding:5px}
.formula-box .item{position: relative;}
.formula-box .item-close{position: absolute;top: -10px;right:0;display: none;border-radius: 18px;width:18px;height:18px;color:#fff;background: #999;font-size: 12px;text-align: center;line-height: 18px;}
.formula-box .item:hover .item-close{display: block}
</style>
